export default class AuthRouter {
  static BASE_PATH = "/auth";
  static LOGIN_ROUTE_NAME = "auth-login";

  static login(): Record<string, unknown> {
    return {
      name: AuthRouter.LOGIN_ROUTE_NAME
    };
  }
}
